import { Component, ElementRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ResponseService, UserData } from '@app/_models';
import { RouteInfo } from '@app/_models/Portal/Menu';
import { AccountService } from '@app/_services';
import { PortalService } from '@app/_services/Portal/portal.services';
import { UsuariosServicesService } from '@app/_services/Usuarios/usuarios-services.service';
import { Subscription } from 'rxjs';
import { first, filter } from 'rxjs/operators';
import swal from 'sweetalert2';

declare const $: any;
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})



export class HeaderComponent {

constructor(
  private accountService: AccountService,
  private portalService: PortalService,
  private element: ElementRef,
  private router: Router,
  private _usuarioService: UsuariosServicesService,
){}

  public menuItems: RouteInfo[];
  menuValue: boolean = false;
  menu_icon: string = 'bi bi-list';
  private dataUser: UserData;
  public isAsociadoPre: boolean = false;
  public isAsociado: boolean = false;
  private _router: Subscription;
  
  ngOnInit() {
    this.dataUser = this.accountService.userInfo;

      if (this.dataUser.Role === 'AsociadoPre') {
        this.isAsociadoPre = true;
      }
      if (this.dataUser.Role === 'Asociado') {
        this.isAsociado = true;
      }
      this.portalService
        .getMenuByRole(this.dataUser.Role)
        .pipe(first())
        .subscribe({
          next: (result) => {
            this.menuItems = result;
            localStorage.setItem('menuItems', JSON.stringify(result));
          },
          error: (error) => {
            console.log('error');
          },
        });

      
        this._router = this.router.events.pipe(
          filter((event) => event instanceof NavigationEnd))
          .subscribe((event: NavigationEnd) => {
            this.closeMenu();

          });
  }



  openMenu() {
    this.menuValue = !this.menuValue;
    this.menu_icon = this.menuValue ? 'bi bi-x' : 'bi bi-list';
  }

  closeMenu() {
    this.menuValue = false;
    this.menu_icon = 'bi bi-list';
  }

  ValidChangePassword() {
    swal
      .fire({
        title: 'Cambio de Contraseña',
        html:
          '<br /><form method="post" id="taxcode-update" name="taxcodeUpdate">' +
          '<input   id="input-contrasena" autofocus  class="form-control wedding-input-text wizard-input-pad" type="password" name="taxCode" placeholder="Contraseña">' +
          '<input   id="input-contrasenaNueva" autofocus  class="form-control wedding-input-text wizard-input-pad" type="password"  placeholder="Contraseña Nueva" >  ' +
          '</form>',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })
      .then((result) => {
        const { isConfirmed } = result;
        if (isConfirmed) {
          if (
            $('#iinput-contrasena').val() === '' ||
            $('#input-contrasenaNueva').val() === ''
          ) {
            swal.fire({
              icon: 'warning',
              html: 'Es obligatorio ingresar los dos campos',
              customClass: {
                confirmButton: 'btn btn-success',
              },
              buttonsStyling: false,
            });
            return;
          }
          if (
            !this.testInputPasswordRegExp($('#input-contrasenaNueva').val())
          ) {
            swal.fire({
              icon: 'warning',
              html: `<div>
                <h4>Error de validacion, la contraseña debe contener:</h4>
                     <ol >
                     <li style="text-align: left;">Al menos una letra mayúscula</li>
                     <li style="text-align: left;">Al menos una letra minúscula</li>
                     <li style="text-align: left;">Al menos un dígito</li>
                    <li style="text-align: left;">Al menos un personaje especial</li>
                    <li style="text-align: left;">Mínimo ocho de longitud</li>
                     </ol></div>`,
              customClass: {
                confirmButton: 'btn btn-success',
              },
              buttonsStyling: false,
            });
            return;
          }
  
          this.CambiarContrasena(
            $('#input-contrasena').val(),
            $('#input-contrasenaNueva').val()
          );
        }
      });
  }
  public testInputPasswordRegExp(text): boolean {
    const reg = new RegExp(
      '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
    );
    const res = reg.test(text);
    return res;
  }

  CambiarContrasena(oldPassword, newPassword) {
    swal.fire('Procesando información');
    swal.showLoading();

    const objetoEnvio = {
      usuario: this.dataUser.RFC,
      contrasena: oldPassword,
      nuevaContrasena: newPassword,
    };
    console.log(objetoEnvio);
    this._usuarioService.CambioPassword(objetoEnvio).subscribe(
      (data: ResponseService) => {
        console.log('response', data);
        if (!data.hasError) {
          swal
            .fire({
              title: 'Contraseña Actualizada Correctamente',
              text: `El cambio se vera reflejado cuando ingreses nuevamente`,
              buttonsStyling: false,
              customClass: {
                confirmButton: 'btn btn-success',
              },
              icon: 'success',
            })
            .then((result) => {
              const { isConfirmed } = result;
              /*  this.goToBack(); */
            });
        } else {
          swal.fire({
            icon: 'error',
            title: '¡Error!',
            text: data.ErrorMsg,
            //footer: '<a href>Why do I have this issue?</a>'
          });
        }
      },
      (error) => {
        swal.fire({
          icon: 'error',
          title: '¡Error!',
          text: 'Ocurrio un error, vuelva a intentarlo nuevamente!',
          //footer: '<a href>Why do I have this issue?</a>'
        });
      }
    );
  }

  //TODO: agregar el metodo ***ValidChangePassword***
}
